import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/realtimePromptProfiles/load',
    method: 'get',
    params,
  })
}

export function get(id) {
  return request({
    url: '/realtimePromptProfiles/get',
    method: 'get',
    params: { id },
  })
}

export function add(data) {
  return request({
    url: '/realtimePromptProfiles/add',
    method: 'post',
    data,
  })
}

export function update(data) {
  return request({
    url: '/realtimePromptProfiles/update',
    method: 'post',
    data,
  })
}

export function del(data) {
  return request({
    url: '/realtimePromptProfiles/delete',
    method: 'post',
    data,
  })
}

// 下拉选项：仅启用中的配置
export function selectable() {
  return request({
    url: '/realtimePromptProfiles/selectable',
    method: 'get',
  })
}

// 某配置可用的音色与目标语言候选
export function options(id) {
  return request({
    url: '/realtimePromptProfiles/options',
    method: 'get',
    params: { id },
  })
}
